import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { CmsSsbtGameConfiguration } from '@nsftx/seven-client-retail-vue-sgp'

export const useGameConfigurationStore = defineStore('gameConfigurationStore', () => {
  const gameConfigurations = ref<CmsSsbtGameConfiguration[]>([])

  const setGameConfigurations = (configs: CmsSsbtGameConfiguration[]) => {
    gameConfigurations.value = configs
  }

  const getByGameId = (gameId: string | undefined) =>
    gameId ? gameConfigurations.value.find((config) => config.game === gameId) : undefined

  return {
    gameConfigurations,
    setGameConfigurations,
    getByGameId
  }
})
